import React, { Component } from 'react';
import { NotificationManager } from 'react-notifications';

import {
  FormGroup,
  Card,
  CardHeader,
  Form,
  Label,
  Input,
  Button,
  Container,
  Row,
  Col,
} from 'reactstrap';

import Header from 'components/Headers/Header.js';
import GeneralQuestionService from './GeneralQuestionService';

const OPTION_TYPES = ['radio', 'checkbox', 'dropdown'];

export default class AddGeneralQuestion extends Component {
  state = {
    text: '',
    type: 'text',
    for_agent: false,
    options: [],
    newOption: '',
    status: true,
    order: 0,
    errors: {},
    loading: false,
  };

  onChangeInput = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    const update = { [e.target.name]: value };
    if (e.target.name === 'type' && !OPTION_TYPES.includes(value)) {
      update.options = [];
    }
    this.setState(update);
  };

  addOption = () => {
    const { newOption, options } = this.state;
    const trimmed = newOption.trim();
    if (!trimmed) return;
    this.setState({ options: [...options, trimmed], newOption: '' });
  };

  removeOption = (index) => {
    const options = this.state.options.filter((_, i) => i !== index);
    this.setState({ options });
  };

  handleOptionKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.addOption();
    }
  };

  validate() {
    const { text, type, options } = this.state;
    const errors = {};
    if (!text.trim()) errors.text = 'Question text is required';
    if (OPTION_TYPES.includes(type) && options.length === 0)
      errors.options = 'At least one option is required for this question type';
    return errors;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const errors = this.validate();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    const { text, type, for_agent, options, status, order } = this.state;
    const payload = { text, type, for_agent, status, order: Number(order) };
    if (OPTION_TYPES.includes(type)) payload.options = options;

    this.setState({ loading: true, errors: {} });
    GeneralQuestionService.createQuestion(payload)
      .then(() => {
        NotificationManager.success('Question created!', 'Success!', 2000);
        this.props.history.push('/admin/general-questions');
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || 'Failed to create question.';
        NotificationManager.error(Array.isArray(msg) ? msg.join(', ') : msg, 'Error', 3000);
        this.setState({ loading: false });
      });
  };

  render() {
    const { text, type, for_agent, options, newOption, status, order, errors, loading } = this.state;
    const needsOptions = OPTION_TYPES.includes(type);

    return (
      <>
        <Header />
        <Container className="mt--7" fluid>
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <h3 className="mb-0">Create General Question</h3>
                </CardHeader>
                <Form onSubmit={this.handleSubmit} style={{ padding: '1.25rem' }}>
                  <FormGroup>
                    <Col sm={12}>
                      <Label for="text">Question Text</Label>
                      <Input
                        type="textarea"
                        name="text"
                        id="text"
                        value={text}
                        onChange={this.onChangeInput}
                        rows={3}
                        placeholder="Enter the question text"
                      />
                      {errors.text && <small className="text-danger">{errors.text}</small>}
                    </Col>
                  </FormGroup>

                  <FormGroup>
                    <Col sm={12}>
                      <Label for="type">Question Type</Label>
                      <Input
                        type="select"
                        name="type"
                        id="type"
                        value={type}
                        onChange={this.onChangeInput}
                      >
                        <option value="text">Text</option>
                        <option value="radio">Radio (single select)</option>
                        <option value="checkbox">Checkbox (multi select)</option>
                        <option value="dropdown">Dropdown</option>
                      </Input>
                    </Col>
                  </FormGroup>

                  {needsOptions && (
                    <FormGroup>
                      <Col sm={12}>
                        <Label>Options</Label>
                        <div className="d-flex mb-2">
                          <Input
                            type="text"
                            value={newOption}
                            onChange={(e) => this.setState({ newOption: e.target.value })}
                            onKeyDown={this.handleOptionKeyDown}
                            placeholder="Type an option and press Add or Enter"
                          />
                          <Button
                            type="button"
                            color="secondary"
                            className="ml-2"
                            onClick={this.addOption}
                          >
                            Add
                          </Button>
                        </div>
                        {options.length > 0 && (
                          <ul className="list-group">
                            {options.map((opt, idx) => (
                              <li
                                key={idx}
                                className="list-group-item d-flex justify-content-between align-items-center py-2"
                              >
                                {opt}
                                <Button
                                  type="button"
                                  color="danger"
                                  size="sm"
                                  onClick={() => this.removeOption(idx)}
                                >
                                  &times;
                                </Button>
                              </li>
                            ))}
                          </ul>
                        )}
                        {errors.options && (
                          <small className="text-danger d-block mt-1">{errors.options}</small>
                        )}
                      </Col>
                    </FormGroup>
                  )}

                  <FormGroup>
                    <Col sm={12}>
                      <Label check>
                        <Input
                          type="checkbox"
                          name="for_agent"
                          checked={for_agent}
                          onChange={this.onChangeInput}
                        />{' '}
                        Show to Agent
                      </Label>
                    </Col>
                  </FormGroup>

                  <FormGroup>
                    <Col sm={12}>
                      <Label check>
                        <Input
                          type="checkbox"
                          name="status"
                          checked={status}
                          onChange={this.onChangeInput}
                        />{' '}
                        Active
                      </Label>
                    </Col>
                  </FormGroup>

                  <FormGroup>
                    <Col sm={12}>
                      <Label for="order">Display Order</Label>
                      <Input
                        type="number"
                        name="order"
                        id="order"
                        value={order}
                        onChange={this.onChangeInput}
                        min={0}
                        placeholder="0"
                      />
                    </Col>
                  </FormGroup>

                  <FormGroup>
                    <Col sm={12}>
                      <Button type="submit" color="primary" className="mr-2" disabled={loading}>
                        {loading ? 'Saving...' : 'Submit'}
                      </Button>
                      <Button
                        type="button"
                        color="secondary"
                        onClick={() => this.props.history.push('/admin/general-questions')}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </FormGroup>
                </Form>
              </Card>
            </div>
          </Row>
        </Container>
      </>
    );
  }
}
